import * as React from "react";
import * as UnderlyingMarkdown from "react-markdown";
import { Table } from "semantic-ui-react";

interface Props {
	source: string;
	renderers?: {};
}

const Markdown: React.SFC<Props> = props => (
	<UnderlyingMarkdown
		source={props.source}
		renderers={{
			table: Table,
			tableHead: Table.Header,
			tableBody: Table.Body,
			tableRow: Table.Row,
			tableCell: ({ isHeader, ...rest }) =>
				isHeader ? (
					<Table.HeaderCell {...rest} />
				) : (
					<Table.Cell {...rest} />
				),
			...props.renderers
		}}
	/>
);
export default Markdown;



// WEBPACK FOOTER //
// ./src/components/WrappedMarkdown/Markdown.tsx